import RowButton from 'components/atoms/row-button'
import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  rowButtonProps: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled : PropTypes.func,
      colour     : PropTypes.string,
      onClick    : PropTypes.func,
      text       : PropTypes.string
    })
  )
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}


/**
 * Columns definition for Seller Outbound Return Item
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const sellerOutboundReturnItemTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {

  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <>
        <RowButton
          data={ row.original }
          color={ buttonColour }
          disabled={ disabled }
          onClick={ onButtonClick }
          text={ buttonText }
        />
      </>
    )
  }

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header  : 'Seller Outbound Return Items',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          }
        ]
      },
      {
        Header  : 'Inbound',
        columns : [
          {
            Header         : 'Code',
            accessor       : 'productable.inbound.code',
            disableFilters : true
          }
        ]
      },
      {
        Header  : 'Product',
        columns : [
          {
            Header         : 'SKU',
            accessor       : 'productable.sku',
            disableFilters : true
          },
          {
            Header         : 'Name',
            accessor       : 'productable.name',
            disableFilters : true
          },
          {
            Header         : 'Category',
            accessor       : 'productable.category',
            disableFilters : true
          }
        ]
      },
      {
        Header  : 'Rejected Product',
        columns : [
          {
            Header         : 'Product Info',
            accessor       : 'productable.rejected_product.product_info',
            disableFilters : true
          },
          {
            Header         : 'Name',
            accessor       : 'productable.rejected_product.rejected_note',
            disableFilters : true
          },
          {
            Header         : 'Category',
            accessor       : 'productable.rejected_product.reject_reason',
            disableFilters : true
          }
        ]
      },
      {
        Header         : 'Action',
        accessor       : 'action',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

sellerOutboundReturnItemTableColumns.propTypes = propTypes

export default sellerOutboundReturnItemTableColumns
